import _ from 'lodash'
import { MutationTree } from 'vuex'
import State from './types'
import { Category, EntityLevel, ManufacturingSeries, Product, ProductClass, Site } from '../types'
import { active, activeNone, current } from '../editor/constants'
import { Topology } from '../editor/types'

export const mutations: MutationTree<State> = {
  treeTopologyLoaded(state: State, { categories }: { categories: Category[] }) {
    state.error = false
    state.treeCategories = categories
  },
  setTreeLoading(state, { value }: { value: boolean }) {
    state.topologyTreeLoadding = value
  },
  setCategoryOpen: (
    state,
    { category, value }: { category: Category; value: boolean },
  ) => {
    category.open = value
    state.categoryOpen[category.CategoryId] = value
  },
  setProductClassOpen: (
    state,
    { productClass, value }: { productClass: ProductClass; value: boolean },
  ) => {
    productClass.open = value
    state.productClassOpen[productClass.ProductClassId] = value
  },
  setManufacturingSeriesOpen: (
    state,
    {
      manufacturingSeries,
      value,
    }: { manufacturingSeries: ManufacturingSeries; value: boolean },
  ) => {
    manufacturingSeries.open = value
    state.manufacturingSeriesOpen[manufacturingSeries.ManufacturingSeriesId] =
      value
  },
  setActiveItem(
    state,
    {
      item,
      entityLevel,
    }: {
      item: Category | ProductClass | ManufacturingSeries | Product | Site
      entityLevel: EntityLevel
    },
  ) {
    state.activeItem = _.assign(
      {},
      activeNone,
      active,
      { entityLevel, Created: false },
      _.pick(item, [
        'CategoryId',
        'ProductClassId',
        'ManufacturingSeriesId',
        'ProductId',
        'SiteId',
        'isNone',
      ]),
    )
  },
  productSectionsLoadingSet(state, isLoading) {
    state.isProductSectionsLoading = isLoading
  },
  setActiveTopology: (
    state,
    { category, productClass, manufacturingSeries, product }: Topology,
  ) => {
    // TODO: make more shallow?
    state.activeTopology = {
      category: _.assign({}, current, category),
      productClass: _.assign({}, current, productClass),
      manufacturingSeries: _.assign({}, current, manufacturingSeries),
      product: _.assign({}, current, product),
    }
  },
  categoriesOpenReset(state) {
    state.categoryOpen = {}
    state.productClassOpen = {}
    state.manufacturingSeriesOpen = {}
    state.productOpen = {}
    const collapsedTree = state.treeCategories.map((category) => {
      return {
        ...category,
        open: false,
        ProductClasses: category.ProductClasses.map((product) => {
          return {
            ...product,
            open: false,
            ManufacturingSeries: product.ManufacturingSeries.map((seri) => {
              return { ...seri, open: false }
            }),
          }
        }),
      }
    })

    state.treeCategories = collapsedTree
    state.isShowingProductModels = false
  },
}
